import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";
import { LEAVE_BADGE, LEAVE_LABEL, downloadLeave } from "@/components/hr/MyLeave";

function Row({ r, onDone }) {
  const [note, setNote] = useState("");
  const decide = (decision) => api.post(`/leave/${r.id}/decide`, { decision, note }).then(() => { toast.success(decision === "approved" ? "Leave approved" : "Leave rejected"); onDone(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="rounded-lg border bg-card p-4" data-testid={`leave-admin-row-${r.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="font-medium"><span translate="no">{r.user_name}</span> · {r.type_label} · {fmtDate(r.start)} – {fmtDate(r.end)} <span className="text-sm text-muted-foreground">{`(${r.days} working days)`}</span></div>
        <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${LEAVE_BADGE[r.status]}`}>{LEAVE_LABEL[r.status]}</span>
      </div>
      <p className="mt-2 whitespace-pre-wrap text-sm" translate="no">{r.reason}</p>
      {r.attachment && <button type="button" className="mt-2 text-sm text-sky-700 underline" onClick={() => downloadLeave(r.id, r.attachment.name)} data-testid={`leave-admin-file-${r.id}`} translate="no">{r.attachment.name}</button>}
      {r.status === "pending" ? (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (required to reject)" className="min-w-[220px] flex-1 rounded-md border bg-background px-3 py-1.5 text-sm" data-testid={`leave-note-${r.id}`} />
          <Button size="sm" onClick={() => decide("approved")} data-testid={`leave-approve-${r.id}`}>Approve</Button>
          <Button size="sm" variant="outline" onClick={() => decide("rejected")} data-testid={`leave-reject-${r.id}`}>Reject</Button>
        </div>) : r.decided_by && <p className="mt-2 text-sm text-muted-foreground">Decision by <span translate="no">{r.decided_by}</span>{r.decision_note && <>: <span translate="no">{r.decision_note}</span></>}</p>}
    </div>
  );
}

export default function LeaveAdmin() {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState(null);
  const load = () => api.get("/leave", { params: status ? { status } : {} }).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="ch chs phd space-y-4" data-testid="leave-admin">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Staff leave requests. Only the System Admin approves or rejects; every decision is audited and the staff member is notified.</p>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-md border bg-background px-2 py-1.5 text-sm" data-testid="leave-admin-filter">
          <option value="pending">Pending</option><option value="approved">Approved</option><option value="rejected">Rejected</option><option value="cancelled">Cancelled</option><option value="">All</option>
        </select>
      </div>
      {!rows ? <p className="text-sm text-muted-foreground">Loading…</p> : !rows.length ? <p className="text-sm text-muted-foreground" data-testid="leave-admin-empty">No leave requests here.</p> : rows.map((r) => <Row key={r.id} r={r} onDone={load} />)}
    </div>
  );
}
